module.exports = __webpack_public_path__ + "img/A v solmsstr na.f93ba915.jpg";